import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

function Calendar({
  minDate = moment().toDate(),
  selected,
  onChange,
  ...rest
}) {
  const calRef = React.useRef();

  const openCalendar = () => {
    calRef.current?.setOpen(true);
  };

  return (
    <div className="calender-customize">
      <DatePicker
        ref={calRef}
        selected={selected}
        onChange={onChange}
        minDate={minDate}
        {...rest}
      />
      <button
        type="button"
        className="calender-customize__icon"
        onClick={openCalendar}
        aria-label="Open calendar"
      >
        <CalendarMonthIcon fontSize="small" />
      </button>
    </div>
  );
}

export default Calendar;
